import { Address } from '../components/HbtPortfolioManagementRequestOverview/components/HbtIndividualLoanDetails/types';

export const provinceCodes: { [key: string]: string } = {
  '00': 'NL',
  '01': 'PE',
  '02': 'NS',
  '03': 'NB',
  '04': 'QC',
  '05': 'ON',
  '06': 'MB',
  '07': 'SK',
  '08': 'AB',
  '09': 'BC',
  '11': 'YT',
  '12': 'NT',
  '13': 'NU'
};

export const formatAddress = (address?: Address) => {
  return `${address?.unitNumber ?? ''} ${address?.streetNumber ?? ''} ${
    address?.streetName ?? ''
  } ${address?.streetTypeID ?? ''} ${address?.streetDirectionID ?? ''} ${
    address?.municipalityName ?? ''
  } ${provinceCodes[address?.provinceID ?? ''] ?? ''} ${address?.postalCode ?? ''}`;
};
